export const shadowTokens = {
  'shadow-none': 'none',
  'shadow-xs': '0 1px 2px rgba(0, 0, 0, 0.05)',
  'shadow-sm': '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
  'shadow-md': '0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)',
  'shadow-lg': '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)',
  'shadow-xl': '0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04)',
  'shadow-focus': '0 0 0 3px var(--dp-color-focus-ring)',
} as const;

export type ShadowTokens = typeof shadowTokens;
